import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {WidgetTreatmentDataInterestedV0Response} from '../models/widget-treatment-data-interested-v0-response';
import {WidgetTreatmentDataInterestedV0CellValue} from '../models/widget-treatment-data-interested-v0-cell-value';
import {IoniconsFilled, IoniconsOutline} from '@pt/pt-models';

@Component({
  selector: 'pt-widget-treatment-data-interested-v0-table',
  templateUrl: './widget-treatment-data-interested-v0-table.component.html',
  styleUrls: ['./widget-treatment-data-interested-v0-table.component.scss']
})
export class WidgetTreatmentDataInterestedV0TableComponent implements OnChanges {

  @Input() row: WidgetTreatmentDataInterestedV0Response[];
  @Input() col: WidgetTreatmentDataInterestedV0Response[];
  @Input() cells: WidgetTreatmentDataInterestedV0CellValue[];
  @Input() preview: boolean;
  @Input() groupByCategory: boolean;

  @Output() toggleCell = new EventEmitter<WidgetTreatmentDataInterestedV0CellValue>();
  @Output() changeValidity = new EventEmitter<boolean>();
  show: boolean;
  groupByCategoryMap: Map<string, WidgetTreatmentDataInterestedV0Response[]> = new Map<string, WidgetTreatmentDataInterestedV0Response[]>();
  categories: string[];
  IconCheck = IoniconsFilled.checkbox;
  IconUncheck = IoniconsOutline.square;

  groupCol = 1;

  isChecked(row: string, col: string): boolean {
    if (this.cells) {
      return !!this.cells?.find((c: WidgetTreatmentDataInterestedV0CellValue) => c.col == col && c.row == row);
    }
    return false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.show = false;

    this.categories = [];
    this.groupByCategoryMap = new Map<string, WidgetTreatmentDataInterestedV0Response[]>();
    this.row?.forEach(r => {
      if (!this.categories?.includes(r.category)) {
        this.categories.push(r.category);
      }
      if (!this.groupByCategoryMap.has(r.category)) {
        this.groupByCategoryMap.set(r.category, [r]);
      } else {
        this.groupByCategoryMap.get(r.category).push(r);
      }
    });
    this.groupCol = this.col?.length + 2;
    this.show = true;
  }

  cellEnter(c: string, r: string) {
    const row = document.getElementById('row_' + r);
    const col = document.getElementById('col_' + c);
    if (row) {
      if (!row.classList.contains(HOVER_CLASS_NAME)) {
        row.classList.add(HOVER_CLASS_NAME);
      }
    }
    if (col) {
      if (!col.classList.contains(HOVER_CLASS_NAME)) {
        col.classList.add(HOVER_CLASS_NAME);
      }
    }
  }

  cellLeave(c: string, r: string) {
    const row = document.getElementById('row_' + r);
    const col = document.getElementById('col_' + c);
    if (row) {
      if (row.classList.contains(HOVER_CLASS_NAME)) {
        row.classList.remove(HOVER_CLASS_NAME);
      }
    }
    if (col) {
      if (col.classList.contains(HOVER_CLASS_NAME)) {
        col.classList.remove(HOVER_CLASS_NAME);
      }
    }
  }
}
const HOVER_CLASS_NAME = 'cell-hover';
